(function() {
  var CONFIG = {
    discounts: {
      vol3:  { code: 'CAFE5VOL',  pct: 5  },
      vol6:  { code: 'CAFE10VOL', pct: 10 },
      vol10: { code: 'CAFEVOL13', pct: 13 },
      offer: { code: 'CAFE10VOL', pct: 10 }
    },
    discountCollection: 'tienda-dsct-auto',
    excludedHandles: ['6kg-gusto-forte','6kg-crema-e-aroma','gusto-forte','crema-e-aroma'],
    excludedFromVol10: ['gusto-forte','crema-e-aroma'],
    fallback: { handle: 'crema-untable-pistacho-200gr' },
    timerSeconds: 297,
    popupTitle: 'Tu nuevo placer 🤩...',
    popupTimerLabel: 'Esta oferta expira en',
    collectionRules: [
      { collection: 'cafe-en-grano',        offers: ['mug-300ml-white','mug-300ml-black','termo-white-600ml','spoon-clip-cuchara-clip'] },
      { collection: 'cafe-de-origen-1',     offers: ['cold-brew-800ml','otto-black-cafetera-turca'] },
      { collection: 'cafe-molido-1',        offers: ['crema-untable-pistacho-200gr','taza-de-espresso-lavazza'] },
      { collection: 'capsulas',             offers: ['taza-de-espresso-lavazza','mug-300ml-white'] },
      { collection: 'capsulas-dolce-gusto', offers: ['taza-de-espresso-lavazza','mug-300ml-black'] },
      { collection: 'tinos',                offers: ['crema-untable-pistacho-200gr'] },
      { collection: 'cremas-dulces',        offers: ['crema-e-aroma','tradizionale-1kg-grano'] },
      { collection: 'mug',                  offers: ['crema-e-aroma','tradizionale-1kg-grano'] },
      { collection: 'termo-para-cafe',      offers: ['buffo-crema-intensa-250gr-molido'] }
    ],
    cartRules: [
      { trigger: { collection: 'cafe-en-grano', tag: '1kg' }, offer: 'crema-untable-pistacho-200gr' },
      { trigger: { collection: 'tinos' },                     offer: 'crema-untable-pistacho-200gr' },
      { trigger: { collection: 'accesorios-cafe' },           offer: 'crema-e-aroma' }
    ]
  };

  var popupShown = false;
  var timerInterval = null;

  /* --------------------------------------------------------------------
     FACTURACION (Bsale). Este motor manda al cliente al checkout desde
     varios puntos (cerrar el popup, "continuar sin agregar", expirar el
     timer). Cuando ese salto se hace directo a /checkout, el cliente se
     salta la pagina del carrito, que es donde se pregunta boleta/factura
     -> Bsale emite boleta por defecto y el cliente reclama.

     Por eso el destino ya no es fijo: si todavia no eligio documento, lo
     mandamos al carrito. Si ya eligio, sigue derecho al checkout y el
     upsell funciona igual que siempre.
     -------------------------------------------------------------------- */
  function destinoPago() {
    try {
      var F = window.CafeterosFact;
      if (F && F.elegido === false) return '/cart#facturacion';
    } catch (e) {}
    return '/checkout';
  }

  function irAlPago() {
    window.location.href = destinoPago();
  }

  function getCart() {
    return fetch('/cart.js').then(function(r){ return r.json(); });
  }

  function getProduct(handle) {
    return fetch('/products/' + handle + '.js').then(function(r){ return r.json(); });
  }

  function applyDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
  }

  function buildDiscountRedirect(code, targetPath) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(targetPath || '/cart');
  }

  function getManualVolumeDiscountCode() {
    try {
      var raw = localStorage.getItem('cf_manual_volume_discount');
      if (!raw) return null;
      var data = JSON.parse(raw);
      var today = new Date().toISOString().split('T')[0];
      if (!data || !data.code || data.date !== today) {
        localStorage.removeItem('cf_manual_volume_discount');
        return null;
      }
      return data.code;
    } catch (e) {
      localStorage.removeItem('cf_manual_volume_discount');
      return null;
    }
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
  }

  function calcDiscountedPrice(price, pct) {
    return Math.round(price * (1 - pct / 100));
  }

  function formatPrice(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

  function closePopup() {
    var overlay = document.getElementById('cf-popup-overlay');
    if (overlay) overlay.style.display = 'none';
    if (timerInterval) clearInterval(timerInterval);
    popupShown = true;
  }

  function startTimer(seconds) {
    var remaining = seconds;
    var timerEl = document.getElementById('cf-popup-timer-count');
    function tick() {
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      var display = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (timerEl) {
        timerEl.textContent = display;
        timerEl.style.color = remaining <= 60 ? '#C70000' : '#1D1B33';
        timerEl.style.fontWeight = remaining <= 60 ? '700' : '400';
      }
      if (remaining <= 0) {
        clearInterval(timerInterval);
        closePopup();
        irAlPago();
      }
      remaining--;
    }
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  function showPopup(product, discountPct, discountCode) {
    var overlay = document.getElementById('cf-popup-overlay');
    if (!overlay) return;
    var variant = product.variants[0];
    var originalPrice = variant.price;
    var salePrice = calcDiscountedPrice(originalPrice, discountPct);
    var img = product.featured_image || (product.images && product.images[0]) || '';

    document.getElementById('cf-popup-title').textContent = CONFIG.popupTitle;
    document.getElementById('cf-popup-img').src = img;
    document.getElementById('cf-popup-img').alt = product.title;
    document.getElementById('cf-popup-product-name').textContent = product.title;
    document.getElementById('cf-popup-price-original').textContent = formatPrice(originalPrice);
    document.getElementById('cf-popup-price-sale').textContent = formatPrice(salePrice);
    document.getElementById('cf-popup-discount-badge').textContent = '-' + discountPct + '%';

    var addBtn = document.getElementById('cf-popup-btn-add');
    addBtn.onclick = function() {
      addToCart(variant.id).then(function() {
        popupShown = true;
        if (timerInterval) clearInterval(timerInterval);
        window.location.href = buildDiscountRedirect(discountCode, '/cart');
      }).catch(function() {
        window.location.href = '/cart';
      });
    };

    document.getElementById('cf-popup-btn-skip').onclick = function() {
      closePopup();
      irAlPago();
    };

    document.getElementById('cf-popup-close').onclick = function() {
      closePopup();
      irAlPago();
    };

    overlay.style.display = 'flex';
    if (CONFIG.timerSeconds > 0) startTimer(CONFIG.timerSeconds);
  }

  function isInCart(cart, handle) {
    return cart.items.some(function(item) {
      return item.handle === handle;
    });
  }

  function getVolumeTrigger(cart) {
    var counts = {};
    cart.items.forEach(function(item) {
      if (CONFIG.excludedHandles.indexOf(item.handle) !== -1) return;
      counts[item.handle] = (counts[item.handle] || 0) + item.quantity;
    });
    var best = null;
    Object.keys(counts).forEach(function(handle) {
      var qty = counts[handle];
      if (qty >= 10 && (!best || qty > best.qty)) best = { handle: handle, qty: qty, rule: CONFIG.discounts.vol10 };
      else if (qty >= 6 && (!best || qty > best.qty)) best = { handle: handle, qty: qty, rule: CONFIG.discounts.vol6 };
      else if (qty >= 3 && (!best || qty > best.qty)) best = { handle: handle, qty: qty, rule: CONFIG.discounts.vol3 };
    });
    return best;
  }

  function runEngine(cart) {
    if (popupShown) { irAlPago(); return; }

    // Regla 1: volumen solo si el cliente eligio explicitamente 3/6 unidades en widget
    var manualVolumeCode = getManualVolumeDiscountCode();
    if (manualVolumeCode) {
      localStorage.removeItem('cf_manual_volume_discount');
      window.location.href = buildDiscountRedirect(manualVolumeCode, destinoPago());
      return;
    }

    // Regla 2: coleccion navegada
    var cols = JSON.parse(localStorage.getItem('cf_collections') || '[]');
    var candidateFromCol = null;
    for (var i = 0; i < cols.length; i++) {
      for (var j = 0; j < CONFIG.collectionRules.length; j++) {
        if (CONFIG.collectionRules[j].collection === cols[i]) {
          var offers = CONFIG.collectionRules[j].offers;
          var randomOffer = offers[Math.floor(Math.random() * offers.length)];
          if (!isInCart(cart, randomOffer)) {
            candidateFromCol = randomOffer;
            break;
          }
        }
      }
      if (candidateFromCol) break;
    }

    // Regla 3: contenido carrito (simplificada por handle)
    var candidateFromCart = null;
    for (var k = 0; k < CONFIG.cartRules.length; k++) {
      var rule = CONFIG.cartRules[k];
      var match = cart.items.some(function(item) {
        return item.handle && item.handle.indexOf(rule.trigger.collection) !== -1;
      });
      if (match && !isInCart(cart, rule.offer)) {
        candidateFromCart = rule.offer;
        break;
      }
    }

    // Prioridad: carrito > coleccion > fallback
    var finalCandidate = candidateFromCart || candidateFromCol || CONFIG.fallback.handle;

    if (isInCart(cart, finalCandidate)) {
      irAlPago();
      return;
    }

    getProduct(finalCandidate).then(function(product) {
      if (!product || !product.available) {
        irAlPago();
        return;
      }
      popupShown = true;
      localStorage.setItem('cf_popup_shown', new Date().toISOString().split('T')[0]);
      showPopup(product, CONFIG.discounts.offer.pct, CONFIG.discounts.offer.code);
    }).catch(function() {
      irAlPago();
    });
  }

  function interceptCheckout(e) {
    /* Solo el boton del mini-carrito, que es el momento natural del upsell
       (justo despues de agregar al carrito).

       Ya NO se intercepta el boton Pagar (#checkout / button[name=checkout]):
       medido en el carrito, el popup tardaba ~15 s en aparecer y en ese rato
       el cliente apretaba Pagar y no pasaba nada. Entre el cliente y el pago
       no va nada. */
    var target = e.target.closest('.ajax-cart__button');
    if (!target) return;
    var alreadyShown = localStorage.getItem('cf_popup_shown');
    var today = new Date().toISOString().split('T')[0];
    if (alreadyShown === today) { return; }
    e.preventDefault();
    e.stopPropagation();
    getCart().then(function(cart) {
      runEngine(cart);
    });
  }

  document.addEventListener('click', interceptCheckout, true);
})();